import Vue from 'vue'
import axios from '../../axios'

export const auth = {
  namespaced: true,
  state: {
    FIREBASE_USER: null,
    FIREBASE_TOKEN: null
  },
  mutations: {
    SET_FIREBASE_USER (state, user) {
      state.FIREBASE_USER = user;
    },
    SET_FIREBASE_TOKEN (state, user) {
      state.FIREBASE_TOKEN = user;
    }
  },
  actions: {
    GET_SESSION_COOKIE({}, idToken){
      return axios.post('/sessionLogin', {idToken})
    }
  },
  getters: {
    GET_FIREBASE_USER (state) {
      return state.FIREBASE_USER
    }
  }
};
